import React from 'react';
import { AttributionControl, ZoomControl } from 'react-leaflet';
import { useTraduzioni } from '../../../i18n';

// Controlli delle mappe del cliente in italiano: i bottoni dello zoom con i titoli nostri (Leaflet scrive
// "Zoom in" / "Zoom out") e l'attribuzione di OpenStreetMap senza il prefisso inglese di Leaflet
// ("A JavaScript library for interactive maps"). Il MapContainer va creato con zoomControl={false} e
// attributionControl={false}: li mette questo componente.
export const TITOLI_ZOOM = { zoomInTitle: 'Ingrandite la mappa', zoomOutTitle: 'Rimpicciolite la mappa' };

const ControlliMappa = () => {
  const { t } = useTraduzioni();
  return (
    <>
      <ZoomControl position="topleft" zoomInTitle={t('immobili.mappa.ingrandite')} zoomOutTitle={t('immobili.mappa.rimpicciolite')} />
      <AttributionControl position="bottomright" prefix={false} />
    </>
  );
};

export default ControlliMappa;
